import React, { ReactElement } from "react";
import { Route } from "react-router-dom";
import NewUser from "../components/login/NewUser/NewUser";
import RegUser from "../components/login/RegUser/RegUser";

import Login from "../layouts/Login";
import Main from "../layouts/Main";
import AuthHome from "../pages/AuthHome/AuthHome";
import Home from "../pages/Home/Home";
import HowAssessmentWorks from "../pages/HowAssessmentWorks/HowAssessmentWorks";
import Registration from "../pages/Registration/Registration";
import ViewMyPropertyDetails from "../pages/ViewMyPropertyDetails/ViewMyPropertyDetails";
import ContactUs from "../pages/ContactUs/ContactUs";
import RfRLanding from "../pages/FileRFR/RfRLanding";
import RfRForm from "../pages/FileRFR/RfRForm";
import NBHDLanding from "../pages/Neighbourhood/NBHDLanding";
import SignOut from "../components/common/AmpSignOut/SignOut";
import ManageMyAccount from "../pages/ManageMyAccount/ManageMyAccount";
import PierPortal from "../layouts/PierPortal";
import ResetPassword from "../pages/ResetPassword/ResetPassword";
import AmppaLogin from "../components/login/AmppaLogin/AmppaLogin";
import Masquerade from "../pages/Masquerade/Masquerade";
import VerifyEmail from "../pages/VerifyEmail/VerfiyEmail";
import LandingToc from "../layouts/LandingToc";
import ResetFinalStep from "../pages/ResetFinalStep/ResetFinalStep";
import PierPortal2 from "../layouts/PierPortalv2";
import AttestPage from "../components/Registration/AttestationEnotifcation/AttestPage";

interface RouteTemplate {
    path: string;
    component: ReactElement;
    subroutes: Array<RouteTemplate> | null;
}

const isAmppa = process.env.REACT_APP_IS_AMPPA === "1";
const isTen = window.localStorage.getItem("o_type") === "ten";

const authedMasquerade = {
    path: "/auth",
    component: <Login />,
    subroutes: [
        {
            path: "masquerade/:token/:id",
            component: <Masquerade />,
            subroutes: null
        },
    ]
}

// Routes for an authenticated User

const authTimeoutRoutes: Array<RouteTemplate> = [
    {
        path: "/amp/signout",
        component: <SignOut />,
        subroutes: null
    }
];

const authTocRoutes: Array<RouteTemplate> = [
    authedMasquerade,
    {
        path: "/toc",
        component: <LandingToc />,
        subroutes: []
    },
    {
        path: "/amp",
        component: <Main />,
        subroutes: [
            {
                path: "contact-us",
                component: <ContactUs />,
                subroutes: null
            },
            {
                path: "signout",
                component: <SignOut />,
                subroutes: null
            },
            {
                path: "enotif",
                component: <AttestPage/>,
                subroutes: null
            }
        ]
    }
];

const newPortalEnabled = process.env?.REACT_APP_NEW_PIER_ENABLED === "1";
const authRoutes: Array<RouteTemplate> = [
    authedMasquerade,
    {
        path: "/pierportalold",
        component: <PierPortal />,
        subroutes: []
    },
    (
        newPortalEnabled ? {
            path: "/pierportal",
            component: <PierPortal2/>,
            subroutes: []
        } :{
            path: "/pierportal",
            component: <PierPortal />,
            subroutes: []
        }
    ),
    {
        path: "/amp",
        component: <Main />,
        subroutes: [
            {
                path: "property-assessment",
                component: <HowAssessmentWorks />,
                subroutes: null,
            },
            {
                path: "property",
                component: <ViewMyPropertyDetails />,
                subroutes: null
            },
            {
                path: "nbhd",
                component: <NBHDLanding />,
                subroutes: null
            },
            {
                path: "",
                component: <Home />,
                subroutes: null
            },
            {
                path: "contact-us",
                component: <ContactUs />,
                subroutes: null
            },
            {
                path: "enotif",
                component: <AttestPage/>,
                subroutes: null
            },
            (!isTen ? 
                {
                    path: "rfr",
                    component: <RfRLanding />,
                    subroutes: null
                } :
                {
                    path: "rfr",
                    component: <></>,
                    subroutes: null 
                }
            )
,
            {
                path: "rfr/rfrform",
                component: <RfRForm />,
                subroutes: null
            },
            {
                path: "signout",
                component: <SignOut />,
                subroutes: null
            },
            {
                path: "signout/:user_profile_id/:username",
                component: <SignOut />,
                subroutes: null
            },
            (isAmppa ?
                {
                    path: "profile",
                    component: <></>,
                    subroutes: null
                }
                :
                {
                    path: "profile",
                    component: <ManageMyAccount />,
                    subroutes: null
                }
            )
        ]
    }
];

// Routes for a non authenticated User
const nonAuthRoutes: Array<RouteTemplate> = [
    {
        path: "/auth",
        component: <Login />,
        subroutes: [
            {
                path: "home",
                component: <AuthHome />,
                subroutes: [
                    {
                        path: "",
                        component: isAmppa ? <AmppaLogin/> : <NewUser />,
                        subroutes: null,
                    },
                    {
                        path: "reg-user",
                        component: isAmppa ? <></> : <RegUser />,
                        subroutes: null
                    },
                ]
            },
            {
                path: "reset/",
                component: <ResetPassword />,
                subroutes: null
            },
            {
                path: "registration/:token",
                component: <Registration />,
                subroutes: null
            },
            {
                path: "contact-us",
                component: <ContactUs />,
                subroutes: null
            },
            {
                path: "masquerade/:token/:id",
                component: <Masquerade />,
                subroutes: null
            },
            {
                path: "verify/:user_profile_id/:username",
                component: <VerifyEmail />,
                subroutes: null
            },
            {
                path: "reset/:user_profile_id/:username/:token",
                component: <ResetFinalStep noCode={false}/>,
                subroutes: null
            },
            {
                path: "reset2/:user_profile_id/:token",
                component: <ResetFinalStep noCode={true}/>,
                subroutes: null
            },
        ],
    },
    {
        path: "/amp",
        component: <Login />,
        subroutes: [
            {
                path: "enotif",
                component: <AttestPage/>,
                subroutes: null
            }
        ]
    }
];

export function generateRoutes(isAuthed: boolean, tocAccepted: boolean, sessionExpired: boolean): Array<JSX.Element> {
    const routes = !isAuthed ? nonAuthRoutes: sessionExpired ? authTimeoutRoutes : tocAccepted ? authRoutes : authTocRoutes ;
    return mapRoutes(routes);
}

function mapRoutes(routes: Array<RouteTemplate>) {
    return routes.map((route: RouteTemplate, index: number) => {
        let children;
        if (route.subroutes != null) {
            children = mapRoutes(route.subroutes);
        }
        return (
            <Route key={index} path={route.path} element={route.component}>
                {children}
            </Route>
        );
    });
}
